import {forgotPassword} from "api/UserAPI";
import {FormForgotPassword} from "components/Forms/FormForgotPassword/FormForgotPassword";
import HeaderLogo from "containers/Auth/HeaderLogo/HeaderLogo";

import {ForgotPasswordTexts} from "i18n/containers/ForgotPassword";
import {ForgotPasswordTranslation} from "i18n/containers/ForgotPassword/typing";
import Link from "next/link";
import * as React from "react";
import {toast, ToastContainer} from "react-toastify";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import Message from "semantic-ui-react/dist/commonjs/collections/Message";
import {Locales} from "@libs";

type ForgotPasswordProps = {
    currentShortLocale: Locales;
}

class ForgotPassword extends React.PureComponent<ForgotPasswordProps> {
    state = {
        loading: false,
        done: false,
        email: "",
        error: "",
    };

    onFormError = (formError: string) => {
        toast.dismiss();
        toast(formError, {type: "error"});

        this.setState(() => ({
            error: formError,
        }));
    };

    onChangeEmail = (email: string) => {
        this.setState(() => ({
            email,
            error: "",
        }));
    };

    onSubmit = () => {
        const {currentShortLocale} = this.props;
        const forgotPasswordTranslation: ForgotPasswordTranslation = {
            ...ForgotPasswordTexts[currentShortLocale],
        };
        toast.dismiss();
        this.setState(() => ({
            loading: true,
        }));

        forgotPassword(this.state.email)().then((res) => {
            if (res.code === 200) {
                toast(forgotPasswordTranslation.checkYourEmail, {type: "success"});
                this.setState(() => ({
                    loading: false,
                    done: true,
                }));
            } else {
                toast(forgotPasswordTranslation.thereWasAnError, {type: "error"});
                this.setState(() => ({
                    loading: false,
                }));
            }
        });
    };

    componentDidMount() {
        toast.dismiss();
    }

    render() {
        const {loading, done} = this.state;
        const {currentShortLocale} = this.props;
        const forgotPasswordTranslation: ForgotPasswordTranslation = {
            ...ForgotPasswordTexts[currentShortLocale],
        };

        return (
            <Grid
                padded
                className="ForgotPassword"
                textAlign="center"
            >
                <Grid.Column
                    className="login-main-column overflow-hidden"
                    computer="6"
                    tablet="16"
                    textAlign="center"
                >
                    <HeaderLogo/>
                    <section className="ForgotPassword__WrapperForm">
                        <h1> {forgotPasswordTranslation.recoverPassword} </h1>
                        <p className="font-color-grey padding-1-bottom font-medium">{forgotPasswordTranslation.findYourVinglet}</p>
                        {done ? (
                            <Message positive>
                                <>
                                    <Message.Header>{forgotPasswordTranslation.yourQueryWasSent}</Message.Header>
                                    {forgotPasswordTranslation.succesfullProcess}
                                </>
                            </Message>
                        ) : (
                            <>
                                <FormForgotPassword
                                    onSubmit={this.onSubmit}
                                    onFormError={this.onFormError}
                                    onChangeEmail={this.onChangeEmail}
                                    loading={loading}
                                    currentShortLocale={currentShortLocale}
                                />
                            </>
                        )}
                        <Link href="/login">
                            <a>{forgotPasswordTranslation.backToTheLogin}</a>
                        </Link>
                    </section>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        draggable
                    />
                </Grid.Column>
            </Grid>
        );
    }
}

export default ForgotPassword;
